const createRipple = (event, elOrRef) => {
  const el = elOrRef?.current ?? elOrRef;
  if (!el) return;

  const ripple = document.createElement("span");
  const rect = el.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const x = event.clientX - rect.left - size / 2;
  const y = event.clientY - rect.top - size / 2;

  ripple.style.width = ripple.style.height = `${size}px`;
  ripple.style.left = `${x}px`;
  ripple.style.top = `${y}px`;
  ripple.className =
    "absolute rounded-full bg-black/10 opacity-50 pointer-events-none animate-ripple";

  el.appendChild(ripple);

  setTimeout(() => {
    ripple.remove();
  }, 600);
};

export default createRipple;
